// Проверка возможности одной из операций из action
export const checkActionAllow = {
    methods: {
        checkActionAllow(operation) {
            if ((this.items && this.items.actionAllows && this.items.actionAllows.includes(operation))
                || (this.actionAllows && this.actionAllows.includes(operation))
                || (this.detailedItem && this.detailedItem.actionAllows && this.detailedItem.actionAllows.includes(operation))) {
                return true
            }
            return false
        },
    }
}

// Action создания и редактирования элемента в объекте items
// Необходимо наличие v-model="isSidebarOpen" ; this.tableApiUrl
export const actionCreateOrUpdateItem = {
    data() {
        return {
            editedItem: {},
            editIndex: -1,
            isSidebarOpen: false,
            validationErrors: '',
            savingProcess: false
        }
    },
    mounted() {
    },
    methods: {
        createOrEditItemModal(index = -1) {
            // Before modal opened
            if (typeof this.beforeSidebarOpenedCallback === 'function') {
                this.beforeSidebarOpenedCallback()
            }

            if (index != -1) {
                this.editIndex = index
                this.editedItem = JSON.parse(JSON.stringify(this.items.data[index]));

                if (typeof this.onItemEditModalCallback === 'function') {
                    this.onItemEditModalCallback()
                }
            }
            
            if (typeof this.onOpenCompanyModalCallback === 'function') {
                this.onOpenCompanyModalCallback()
            }

            this.isSidebarOpen = true

            // After sidebar opened
            if (typeof this.afterSidebarOpenedCallback === 'function') {
                this.afterSidebarOpenedCallback()
            }
        },
        createOrUpdateItem() {
            this.savingProcess = true
            if (typeof this.onCreateOrUpdateItemCallback === 'function') {
                this.onCreateOrUpdateItemCallback();
            }
            if (this.editIndex == -1) {
                api.call("post", this.tableApiUrl, this.editedItem).then(({data}) => {
                    this.items.data.unshift(data);
                    if (typeof this.onCreatedOrUpdatedCallback === 'function') {
                        this.onCreatedOrUpdatedCallback(data)
                    }
                    if (typeof this.updateParentData === 'function') {
                        this.updateParentData()
                    }

                    this.validationErrors = '';
                    this.savingProcess = false;
                    this.closeSidePanelCallback();
                    this.makeToast('success');
                }).catch((response) => {
                    if (response.status == 422){
                        this.validationErrors = response.data.error
                    }
                })
            } else {
                const index = this.editIndex;
                api.call('put', `${this.tableApiUrl}/${this.editedItem.id}`, this.editedItem).then(({data}) => {
                    Object.assign(this.items.data[index], data);
                    if (typeof this.onCreatedOrUpdatedCallback === 'function') {
                        this.onCreatedOrUpdatedCallback(data)
                    }
                    this.editIndex = -1;
                    this.savingProcess = false;
                    this.validationErrors = '';
                    this.closeSidePanelCallback();
                    this.makeToast('success');
                }).catch((response) => {
                    if (response.status == 422){
                        this.validationErrors = response.data.error
                    }
                })
            }
        },
        closeSidePanelCallback() {
            if (!this.isSidebarOpen) {
                this.editIndex = -1
                if (typeof this.onSidePanelCallback === 'function') {
                    this.onSidePanelCallback() // clear custom fields of form
                }
            }
        },
    }
}
// Action удаления элемента из объекта items
// Необходимо наличие this.tableApiUrl
export const actionDeleteItem = {
    methods: {
        deleteItem(index) {
            let id = this.items.data[index].id

            this.$swal({
                title: 'Подтвердите удаление',
                icon: 'question',
                showCancelButton: true,
                cancelButtonText: 'Нет',
                confirmButtonText: 'Да',
            }).then((result) => {
                if(result.isConfirmed){
                    if (typeof this.dataOverlay !== 'undefined') { this.dataOverlay = true; }
                    
                    api.call("delete", `${this.tableApiUrl}/${id}`).then(({data}) => {
                        setTimeout(() => {
                            this.items.data.splice(index, 1);

                            if (typeof this.onDeletedCallback === 'function') {
                                this.onDeletedCallback();
                            }

                            if (typeof this.dataOverlay !== 'undefined') { this.dataOverlay = false; }
                            this.makeToast('danger');
                        }, 1000);
                    }).catch((response) => {
                        console.error(response);
                        if (typeof this.dataOverlay !== 'undefined') { this.dataOverlay = false; }
                    })
                }
            }).finally(() => {
            })
        },
    }
}

// Action копирования элемента из объекта items
// Необходимо наличие this.tableApiUrl
export const actionCopyItem = {
    data() {
        return {
            isCopying: false
        }
    },
    methods: {
        copyItem(index) {
            // Защита от двойного клика
            if (this.isCopying) {
                return;
            }

            let id = this.items.data[index].id

            this.$swal({
                title: 'Подтверждаете желание скопировать',
                icon: 'question',
                showCancelButton: true,
                cancelButtonText: 'Нет',
                confirmButtonText: 'Да',
                allowOutsideClick: false,
                allowEscapeKey: false
            }).then((result) => {
                if(result.isConfirmed){
                    this.isCopying = true;
                    
                    // Показываем простое уведомление о копировании
                    this.$swal({
                        title: 'Копирование...',
                        text: 'Пожалуйста, подождите',
                        allowOutsideClick: false,
                        allowEscapeKey: false,
                        showConfirmButton: false,
                        timer: false
                    });

                    api.call("get", `${this.tableApiUrl}/copy/${id}`)
                        .then(({data}) => {
                            this.items.data.unshift(data);
                            this.closeSidePanelCallback();
                            
                            // Показываем уведомление об успехе
                            this.$swal.close();
                            this.makeToast('success', 'Заказ успешно скопирован');
                        })
                        .catch((error) => {
                            console.error('Ошибка при копировании заказа:', error);
                            this.$swal.close();
                            this.makeToast('error', 'Ошибка при копировании заказа');
                        })
                        .finally(() => {
                            this.isCopying = false;
                        });
                }
            });
        },
    }
}

// Action оценка элемента из объекта items
// Необходимо наличие this.tableApiUrl
export const actionScoreItem = {
    data() {
        return {
            openScoreBoxIndex: -1,
            openScoreBoxItemId: -1,
        }
    },
    methods: {
        scoreItem(index) {
            let id = this.items.data[index].id

            this.$swal({
                title: 'Оценить поставку',
                icon: '',
                showCancelButton: true,
                cancelButtonText: 'Нет',
                confirmButtonText: 'Да',
            }).then((result) => {
                if(result.isConfirmed){
                    this.openScoreBoxIndex = index
                    this.openScoreBoxItemId = this.items.data[index].id
                }
            }).finally(() => {
                this.makeToast('success')
            })
        },
        scoringItemClose() {
            this.openScoreBoxIndex = -1
            this.openScoreBoxItemId = -1
        }
    }
}

// Action просмотра карточки подробностей
// Необходимо наличие v-model="isSidebarOpenDetail" ; this.tableApiUrl
export const actionShowItem = {
    data() {
        return {
            detailedItem: {
                creator: {},
                type: {},
                sales_manager: {},
                source: {},
                company: {},
                companies: [],
                company_employee: {},
                client: {},
                status: {},
                order: {},
                service: {},
                service_for_partner: {},
                services_list: {},
                selected_services: [],
                user: {},
                close_reason: {},
                documents: {},
                teo_manager: {},
                to_manager: {},
                optional_sales_manager: {},
                finance_substatuses: [],
                passport_checked: {},
                driver_card_checked: {},
                passport_file_photo: {},
                passport_file_address: {},
                driver_card_file_face: {},
                driver_card_file_back: {},
                truck_type: {},
                truck_body_type: {},
                checked: {},
                ctc_file_face: {},
                ctc_file_back: {},
                ptc_file_face: {},
                ptc_file_back: {},
                rent_file: {},
                order_substatuses: {},
                contacts: {
                    lead_fio: "",
                    lead_email: "",
                    lead_phone: "",
                },                
            },
            isSidebarOpenDetail: false,
            detailedItemIndex: -1
        }
    },
    methods: {
        showItem(index, tabSelector = '', name) {
            let id = this.items.data[index].id;
            
            if (this.$route.name === 'orders' && name !== 'finance') {
                this.openOrderSidebar(id);
            } else if (this.$route.name === 'companies' && name !== 'finance') {
                this.openCompanySidebar(id);
            } else  if (name === 'finance') {
                this.openFinanceSidebar(id);
            } else {
                api.call("get", `${this.tableApiUrl}/${id}`).then(({data}) => {
                    this.detailedItem = data
                    this.isSidebarOpenDetail = true
                    this.detailedItemIndex = index
                    // If this element exist in table lets update
                    if (typeof this.items !== 'undefined' && this.items.data[index]) {
                        this.items.data[index] = Object.assign(this.items.data[index], data)
                    }
                }).finally(() => {
                    if (tabSelector != '') {
                        // $(tabSelector).tab('show')
                        $(tabSelector)[0].click()
                    }
                })
            }
        },
    }
}

// Рекурсивная функция для создания древовидной структуры из одномерного массива
export const makeTree = {
    methods: {
        makeTree(elements, parent_indeficator = 'parent_id', parent = null) {
            let children = [];
            elements
              .filter((node) => node[parent_indeficator] === parent)
              .forEach((node, idx) => {
                  children[idx] = {
                    ...node,
                    children: this.makeTree(elements, parent_indeficator, node.id),
                  }
              });
            return children;
          },
    }
}
